module.exports = __webpack_public_path__ + "static/media/1levelEveryHight.fce0a034.jpg";